<template>
  <div class="statistics-line">
    <div class="statistics-line__title">
      통계 테이블
    </div>
    <div class="statistics-table__chart">
      <div class="looks-like-table">
        <div
          class="table-column"
          v-for="(column, ci) in itemStatistics"
          :key="ci"
        >
          <div class="table-td" v-for="(row, ri) in column" :key="ri">
            <div class="table-type" v-if="ci === 0">
              {{ row.data }}
            </div>

            <div class="table-date" v-else-if="ri === 0">
              {{ row.data.date }}
            </div>

            <div class="table-data" v-else>
              <div v-if="row.data === null">
                -
              </div>
              <div class="table-data-click-view" v-else>
                <div class="view">{{ row.data.view }} .v</div>
                <div class="click">{{ row.data.click }} .c</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "StatisticsTableChart",
  data: () => ({}),
  props: {
    statistic: Array,
    itemStatistics: Array,
  },
  computed: {
    tHeader() {
      return this.statistic && this.statistic[0];
    },
  },
  methods: {},
};
</script>
<style lang="scss">
@import "~styles/color";
@import "~styles/size";

.statistics-table {
  margin: 16px 8px 16px 8px;
  padding: 24px;
  border-radius: 5px;

  &__chart {
    overflow: auto;
    margin-top: 24px;
    border: 1px solid #e0e0e0;
  }

  &__title {
    font-size: 15px;
    margin-bottom: 16px;
    color: #595959;
  }
}

@media (max-width: $min_layout) {
  .statistics-table {
    padding: 24px 16px;

    &__chart {
      flex-direction: column;

      &-type {
        padding-top: 16px;
      }
    }
  }
}

.looks-like-table {
  width: 100%;
  display: flex;
  font-size: 1.4rem;

  .table-column {
    flex: 1;
    border-right: 1px solid rgb(224, 224, 224);
    text-align: right;

    &:last-child {
      background-color: rgb(225, 255, 250);
      border-right: none;
      position: sticky;
      right: 0;
      box-shadow: -2px 0 6px 0 rgba(0, 0, 0, 0.05);

      .table-td {
        background-color: rgb(225, 255, 250);
      }

      .table-td:last-child {
        background-color: #aaf7ff;
      }
    }

    &:first-child {
      width: 120px;
      font-size: 14px;
      flex: none;
      position: sticky;
      left: 0;
      background-color: white;

      .table-td {
        justify-content: center;
      }
    }
  }

  .table-td {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: 70px;
    padding: 0 14px;
    background-color: white;
    border-bottom: 1px solid rgb(224, 224, 224);

    &:last-child {
      background-color: rgb(235, 246, 255);
      border-bottom: none;
    }

    &:first-child {
      height: 46px;
    }

    .table-data-click-view {
      .click,
      .view {
        padding: 4px 0;
      }
    }
  }
}
</style>
